export enum MaterialStatus {
	ACTIVE = "ACTIVE",
	INACTIVE = "INACTIVE",
}

export type Material = {
	id?: number;
	createdAt?: Date;
	updatedAt?: Date;
	label: string;
	sageId: string;
	status: MaterialStatus;
	number: string;
};
